import { css } from '@emotion/react';

import { AGE_GROUP_ID } from '../../const';
import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, screenSizes, spacing, colors, utility, mediaQueries } =
    useTheme();

  return {
    base: (backlinkcta, nextLinkCta, questionOrder) => css`
      display: grid;
      align-items: center;
      grid-gap: ${spacing.s};
      width: 100%;
      justify-content: center;

      ${backlinkcta === true &&
      css`
        animation: moveLeft 1s ease-in-out;
        /* Keyframes animation for left - right  movement */
        @keyframes moveLeft {
          25% {
            margin-left: 57%;
            opacity: 0;
          }
          50% {
            margin-left: -50%;
            opacity: 0;
          }
          100% {
            margin-left: 0;
          }
        }
      `}
      ${nextLinkCta === true &&
      css`
        animation: moveRight 1s ease-in-out;
        /* Keyframes animation for left - right movement */
        @keyframes moveRight {
          25% {
            margin-left: -90%;
            opacity: 0;
          }
          50% {
            margin-left: 90%;
            opacity: 0;
          }
          100% {
            margin-left: 0;
          }
        }
      `}
      

      ${breakpoints.l} {
        grid-template-columns: 1fr 1fr;
        align-items: center;
        grid-gap: ${questionOrder === 6 ? '1rem' : '3rem'};

        ${backlinkcta === true &&
        css`
          animation: moveLeft 1s ease-in-out;
          /* Keyframes animation for left - right movement */
          @keyframes moveLeft {
            25% {
              margin-left: 57%;
              opacity: 0;
            }
            50% {
              margin-left: -50%;
              opacity: 0;
            }
            100% {
              margin-left: 0;
            }
          }
        `}
        ${nextLinkCta === true &&
        css`
          animation: moveRight 1s ease-in-out;
          /* Keyframes animation for left - right movement */
          @keyframes moveRight {
            25% {
              margin-left: -50%;
              opacity: 0;
            }
            50% {
              margin-left: 50%;
              opacity: 0;
            }
            100% {
              margin-left: 0;
            }
          }
        `}
      }

      ${mediaQueries.zoomedIn} {
        padding-bottom: ${spacing.m};
      }
    `,
    answers: questionOrder => css`
      order: 2;
      ${mediaQueries.zoomedIn && questionOrder !== 6} {
        padding-left: 5px;
        padding-right: 5px;
      }
      transform: rotate(0deg);
    `,
    spacingDiv: css`
      ${breakpoints.m} {
        display: grid;
        grid-template-columns: 3.125rem 3.125rem;
        padding-top: 22px;
        cursor: initial;
        place-items: center;
      }
    `,
    divWidth: css`
      width: 327px;

      ${breakpoints.l} {
        width: 446px;
      }
    `,
    spacingDivMob: (isIpad, isSmallMobile, isMobile) => css`
      display: grid;
      grid-template-columns: 3.125rem 3.125rem;
      position: absolute;
      top: calc(100vh - 37vh);
      left: calc(100% - 10%);
      // border: 1px solid red;
      width: 92px;

      ${isMobile &&
      css`
        top: calc(100% - 10%);
        left: calc(100% - 42%);
        position: fixed;
      `}

      ${isIpad &&
      css`
        left: calc(100% - 10%);
        // border: 1px solid white;
      `}
                  
      ${isSmallMobile &&
      css`
        position: fixed;
        top: calc(106vh - 14vh);
        left: calc(100% - 33%);
        // border: 1px solid yellow;
      `}
    `,
    title: readableId => css`
      font-family: 'FS Dillon' !important;
      font-size: ${spacing.m};
      line-height: 2.25rem;
      letter-spacing: 0.0013em;
      text-align: start;
      color: ${colors.white};
      margin-bottom: ${spacing.xs};
      width: ${readableId === AGE_GROUP_ID ? '91%' : '85%'};
      font-style: normal !important;
      font-size: 25.92px;
      width: 90%;

      &:focus {
        outline: none;
      }

      ${breakpoints.l} {
        width: 100%;
        text-align: left;
        font-size: 35.54px;
        line-height: 3.125rem;
        letter-spacing: 0.0018em;
        margin-left: 0;
        font-style: normal;
        margin-bottom: 7px;
        font-family: 'FS Dillon' !important;
      }
    `,
    helpText: readableId => css`
      color: ${colors.lightBlue};
      text-align: start;
      margin-bottom: 2.5rem !important;
      letter-spacing: 0.0027em;
      font-size: 18px;
      height: 16px;

      ${breakpoints.l} {
        margin-right: ${readableId === AGE_GROUP_ID ? '5rem' : '4rem'};
        margin-bottom: 26px;
        text-align: left;
        font-size: 20px;
      }
    `,
    down: (arrowContext, questionOrder, quickSearch) => css`
      display: flex;
      transform: rotate(90deg);
      ${questionOrder === 1 && (quickSearch && questionOrder === 7) &&
      css`
        > svg {
          cursor: initial;
        }
      `}

      ${questionOrder !== 1 && !(quickSearch && questionOrder === 7) && 
      css`
        > svg {
          cursor: pointer;
          @media (min-width: 768px) {
            &:hover {
              fill: #ffffff;
              path {
                stroke: #16161e;
              }
            }
          }
        }
      `}
      &:focus-visible {
        outline: none;
        border: none;
          svg {
            outline: 2px solid ${colors.skip_yellow};
            border: 2px solid ${colors.border_black};
            border-radius: 4px;
          }
        }
    `,
    up: arrowContext => css`
      transform: rotate(90deg);
      > svg {
        cursor: pointer;
        ${arrowContext === true &&
        css`
          &:hover {
            fill: #ffffff;
            path {
              stroke: #16161e;
            }
          }
        `}

        ${arrowContext === false &&
        css`
          transform: rotate(180deg);
          // transform-origin: 26% 50%;
          cursor: initial;
        `}
      }
        &:focus-visible {
        outline: none;
        border: none;
          svg {
            outline: 2px solid ${colors.skip_yellow};
            border: 2px solid ${colors.border_black};
            border-radius: 4px;
          }
        }
    `,
    helpquestion: css`
      font-size: 12.5px;
      margin-bottom: 12px;
      letter-spacing: 2px;
      font-weight: 700 !important;

      ${breakpoints.l} {
        font-size: 15px;
        margin-bottom: 12px;
      }
    `,
    fieldset: css`
      display: contents;

      legend {
        ${utility.checkboxHidden}
      }
    `,
    infoLink: css`
      margin-top: ${spacing.s};
      text-align: start;

      ${breakpoints.l} {
        margin-top: ${spacing.m};
      }

      ${mediaQueries.zoomedIn} {
        background-position: 0 180%;
      }
    `,
    progressBar: css`
      margin-bottom: ${spacing.m};

      @media (max-width: ${screenSizes.l}) {
        position: absolute;
        top: 14%;
        left: 0;
      }

      ${mediaQueries.zoomedIn} {
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 2.5rem);
      }
    `,
    helpSecText: css`
      margin-bottom: 0;
      
      @media screen and (max-device-width: 992px) {
        height: auto;
      }

      ${breakpoints.l} {
        margin: 0.8rem 5rem 0 0;
        padding-bottom: 1.5rem;
      }
    `,
  };
};
